import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-footer-historia-cenpresabil',
  templateUrl: './footer-historia-cenpresabil.component.html',
  styleUrls: ['./footer-historia-cenpresabil.component.css']
})
export class FooterHistoriaCenpresabilComponent implements OnInit, OnChanges {

  @Input() public objetoObservaciones : ObjetoObservacionesEntity = {
    nombreMedico : "",
    registroMedico : "",
    firmaMedico : "",
    firmaPaciente : ""
  }

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getObjetoObservaciones();
  }

  private async getObjetoObservaciones() {
    try {
      await this.objetoObservaciones;
    } catch(exception) {
      console.log(exception);
    }
  }

}

interface ObjetoObservacionesEntity {
  nombreMedico : string,
  registroMedico : string,
  firmaMedico : string,
  firmaPaciente : string
}
